import * as React from 'react';
import { StoreContext } from '../../utils';
import { Store } from '../../store/Store';
import { PortalHeaderTopbarUser } from './PortalHeaderTopbarUser';

export class PortalHeaderTopbar extends React.Component {
  static contextType = StoreContext;
  declare context: Store;

  render() {
    return (
      <div className="topbar">
        {/*begin::Tablet & Mobile Search*/}
        {/*end::Tablet & Mobile Search*/}
        {/*begin::Notifications*/}
        {/*end::Notifications*/}
        {/*begin::Quick Actions*/}
        {/*end::Quick Actions*/}
        {/*begin::My Cart*/}
        {/*end::My Cart*/}
        {/*begin::Quick panel*/}
        {/*end::Quick panel*/}
        {/*begin::Chat*/}
        {/*end::Chat*/}
        {/*begin::User*/}
        <PortalHeaderTopbarUser />
        {/*end::User*/}
      </div>
    );
  }
}
